import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "modal-template__inner" }
const _hoisted_2 = { class: "modal-template__body custom-scrollbar" }

import { onMounted, onBeforeUnmount } from 'vue';
    import CloseIcon from '@/components/commons/icons/CloseIcon.vue';

    interface ModalTemplateProps {
        darkOverlay?: boolean;
        closeBtn?: boolean;
        scrollBodyLock?: boolean;
        mode?: 'gallery' | 'filter' | 'list';
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ModalTemplate',
  props: {
    darkOverlay: { type: Boolean },
    closeBtn: { type: Boolean },
    scrollBodyLock: { type: Boolean },
    mode: {}
  },
  emits: ['close', 'openFilter', 'openList'],
  setup(__props: any, { emit: __emit }) {

    const props = __props;

    const emits = __emit;

    onMounted(() => {
        if (props.scrollBodyLock) document.body.style.overflow = 'hidden';
    });

    onBeforeUnmount(() => {
        document.body.style.overflow = 'auto';
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["modal-template", [
            {
                'modal-template--dark': _ctx.darkOverlay,
            },
            _ctx.mode
                ? `modal-template--mode-${_ctx.mode}`
                : `modal-template--mode-default`,
        ]]),
    onPointerdown: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "modal-template__btn-close",
        type: "button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, [
        _createVNode(CloseIcon, { class: "modal-template__btn-close-icon" })
      ]),
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ])
  ], 34))
}
}

})